<template>
  <div id="order_food">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $t("OrderFood.OrderFood") }}
            <span
              class="introduction"
              @click="$toExternaLink('https://www.smartdaily.com.tw/ordering-system-operation/')"
            >{{ $t("General.Instructions") }}</span>
          </div>
          <div class="tip">
            {{ $t("OrderFood.PointTransactionFoodItems") }}
          </div>
        </div>
        <div class="right">
          <el-tooltip class="item" effect="dark" :content="$t('OrderFood.HaveSelectedFoodItemsCannotUseManagement')" placement="top" :disabled="selectedFoodItems.length <= 0">
            <el-button
              plain
              :disabled="selectedFoodItems.length > 0"
              @click="orderFoodItemManagement"
            >
              {{ $t("OrderFood.OrderItemManagement") }}
            </el-button>
          </el-tooltip>
          <el-button
            plain
            @click="orderFoodRecord"
          >
            {{ $t("OrderFood.OrderFoodRecord") }}
          </el-button>
        </div>
      </div>
      <el-tabs
        v-model="activeName"
        :before-leave="beforeLeave"
      >
        <el-tab-pane
          :label="$t('OrderFood.Step1') + $t('OrderFood.SelectFoodItems')"
          name="1"
        >
          <SelectFoodItems
            @selectPointType="selectPointType"
            @selectFoodItems="selectFoodItems"
          />
          <div class="footer-container">
            <el-button
              type="primary"
              round
              :disabled="isPointsInsufficient"
              @click="nextStep"
            >
              {{ $t('OrderFood.NextStep') }}
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('OrderFood.Step2') + $t('OrderFood.PointsConfirmation')"
          name="2"
        >
          <PointConfirmation
            ref="pointConfirmation"
            :selected-food-items="selectedFoodItems"
            :selected-point-type="selectedPointType"
            :selected-household-id="selectedHouseholdId"
            :is-active="activeName === '2'"
            @gotoTab="gotoTab"
            @printResult="printResult"
          />
          <div class="footer-container">
            <el-button
              type="primary"
              round
              @click="nextStep"
            >
              {{ $t('OrderFood.ConfirmSubmit') }}
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('OrderFood.Step3') + $t('OrderFood.PointsTransaction')"
          name="3"
        >
          <PointTransaction
            @getTypeData="handleGetTransactionData"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <SelectHouseholds
      :household-arr="householdArr"
      @selectHousehold="selectHousehold"
    />
    <PrinterResultDialog ref="printerResultDialog" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SelectFoodItems from './components/SelectFoodItems'
import PointConfirmation from './components/PointConfirmation.vue'
import PointTransaction from './components/PointTransaction'
import SelectHouseholds from './components/SelectHouseholds'
import PrinterResultDialog from './components/PrinterResultDialog'
export default {
  components: {
    SelectFoodItems,
    PointConfirmation,
    PointTransaction,
    SelectHouseholds,
    PrinterResultDialog
  },
  data () {
    return {
      activeName: '1',
      householdArr: [], // 戶別資料陣列
      selectedHouseholdId: null, // 選擇的戶別
      selectedPointType: 1, // 選擇的點數類型(1: 一般點數, 2: 現金點數)
      selectedFoodItems: [], // 選擇的餐點品項
      deductionType: 0 // 扣點方式(1: 直接選擇戶別, 2: 手機條碼, 3: 門禁卡、磁扣)
    }
  },
  computed: {
    ...mapState({
      isPointsInsufficient: state => state.orderFood.currentTransaction.isPointsInsufficient
    })
  },
  activated () {
    // 進入點餐頁面時先重置目前交易資料
    this.$store.commit('setCurrentTransactionHouseholdInfo', { tabletId: '', tabletNote: '', normalPoint: 0, cashPoint: 0 })
    this.$store.commit('setCurrentTransactionPointsInsufficient', false)
  },
  methods: {
    // 前往點餐使用項目管理頁面
    orderFoodItemManagement () {
      this.$router.push({ name: 'orderFoodItemManagement' })
    },
    // 前往點餐紀錄頁面
    orderFoodRecord () {
      this.$router.push({ name: 'orderFoodRecordList' })
    },
    // 上一步
    previousStep () {
      this.activeName = (parseInt(this.activeName, 10) - 1).toString()
    },
    // 下一步
    nextStep () {
      this.activeName = (parseInt(this.activeName, 10) + 1).toString()
    },
    /**
     * 處理離開頁籤前的事件
     */
    beforeLeave (nV, oV) {
      if (nV > oV) {
        if (nV >= '2') {
          if (this.selectedFoodItems.length === 0) {
            this.$message({
              message: this.$t('OrderFood.PleaseSelectItems'),
              type: 'warning'
            })
            this.activeName = oV
            return false
          }
        }
      }
    },
    // 前往指定頁籤
    gotoTab (val) {
      this.activeName = val.toString()
    },
    // 選擇點數類型
    selectPointType (val) {
      this.selectedPointType = val
    },
    // 選擇餐點品項
    selectFoodItems (val) {
      this.selectedFoodItems = val
    },
    /**
     * 處理取得扣點方式與對應內容
     * @param {number} type 扣點方式(1: 直接選擇戶別, 2: 手機條碼, 3: 門禁卡、磁扣)
     * @param {array} householdList 戶別資料陣列
     */
    handleGetTransactionData (type, householdList) {
      this.deductionType = type
      if (householdList.length === 1) {
        // 單一戶別，直接扣點
        this.submit(householdList[0])
      } else {
        // 多戶別，選擇戶別
        this.householdArr = householdList
      }
    },
    /**
     * 處理從選擇戶別對話框的送出
     * @param {object} val 戶別資料
     */
    selectHousehold (val) {
      this.submit(val)
    },
    /**
     * 處理確認送出
     * @param {object} householdData 戶別資料
     */
    submit (householdData) {
      this.$refs.pointConfirmation.submit(this.deductionType, householdData)
    },
    // 列印交易明細單
    printResult (val) {
      this.$refs.printerResultDialog.setVal(val)
    }
  }
}
</script>

<style lang="scss" scoped>
#order_food {
  @include mainLayer();
  .el-tabs {
    @include TabsToSteps();
  }
  .footer-container {
    padding-top: 20px;
  }
}
</style>
